import {
  generalAdabyronBehaviour,
  USER_TYPES,
} from '../../utils/adaByron';
import { Context, MethodType } from '../../utils/types';
import { normalizeGetAddressResponse } from './normalizers';

export enum PATHS {
  GET_ADDRESS = 'venta/buscar/localizacionDireccion',
  TRANSLATE_LOCATION_TO_ZELERIS_FORMAT = 'venta/buscar/localizacion',
}

export const getAddress = (
  data: {
    horizontalAddress: string;
    verticalAddress: string;
  },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const { horizontalAddress, verticalAddress } = data;
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.GET_ADDRESS,
    userTypes: [USER_TYPES.CLIENT, USER_TYPES.TGES, USER_TYPES.OPEN],
    eventName: 'ADDRESSES.GET_ADDRESS',
    queryParams: [
      {
        param: 'direccion',
        value: horizontalAddress.replace(/,/g, ''),
      },
      {
        param: 'vertical',
        value: verticalAddress,
      },
    ],
    mockedInfo: 'getAddress',
    methodType: MethodType.GET,
    onSuccessNormalizer: normalizeGetAddressResponse,
    telcoHostVersion: 10,
  });
};

export const translateLocationToZelerisFormat = (
  data: {
    locationId: string;
  },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const { locationId } = data;
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.TRANSLATE_LOCATION_TO_ZELERIS_FORMAT,
    userTypes: [USER_TYPES.CLIENT],
    eventName: 'ADDRESSES.TRANSLATE_LOCATION_TO_ZELERIS_FORMAT',
    queryParams: [{ param: 'id', value: locationId }],
    mockedInfo: 'translateLocationToZelerisFormat',
    methodType: MethodType.GET,
    telcoHostVersion: 10,
  });
};
